export const KEYS_CODES = {
	enter: 13,
};
